module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/noProducts.1ab09bf0.svg";